import { useMemo } from 'react';
import { useQuery } from 'react-query';
import useFetchOrganizationLocations from './useFetchOrganizationLocations';
import useFetchHealthcareServices from './useFetchHealthcareServices';

export default (appointmentId) => {
  const { data: { data } = {}, isLoading, isSuccess } = useQuery(['GET', `/apis/v2/appointments/${appointmentId}`, {}]);

  const { data: locations } = useFetchOrganizationLocations();
  const { data: services } = useFetchHealthcareServices();
  const relatedData = useMemo(() => {
    if (data) {
      const locationId = data?.relationships?.location?.data?.id;
      const healthcareServiceId = data?.relationships?.healthcareService?.data?.id;
      return {
        locationId,
        healthcareServiceId,
        location: locations.find((x) => x.id === locationId),
        service: services.find((x) => x.id === healthcareServiceId),
      };
    }
    return null;
  }, [data, locations, services]);
  return { data: data?.attributes || null, relatedData, isLoading, isSuccess };
};
